module.exports = __webpack_public_path__ + "static/media/mapPerson.cd522b1b.svg";